import { createSelector } from '@ngrx/store';
import find from 'lodash/find';

import { getCitation } from './get.citations';
import { NumberedRefToDeleteFromDoc } from '../../models';

export const getNumberCitationToDeleteFromDoc = createSelector(
  [getCitation],
  ({
    references,
    delFromDocCitationId,
    delFromDocCitationCount,
  }): NumberedRefToDeleteFromDoc | null => {
    const ref = find(
      references,
      (reference) => reference.referencedBy[0] === delFromDocCitationId
    );
    return ref
      ? {
          ...ref,
          citationCount: delFromDocCitationCount,
        }
      : null;
  }
);
